import React from 'react'
import { Container } from 'react-bootstrap'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { BiSearch } from "react-icons/bi"
import { gsap, Power3 } from 'gsap';
import { useRef, useEffect } from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link } from 'react-router-dom';
import "./BlogNav.css"
import { useAuth } from '../context/AuthContext';
import Modal from 'react-bootstrap/Modal';
import { BiLogOutCircle } from "react-icons/bi"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import firebase from 'firebase/compat/app';
import { useState } from 'react';
import FlagDisplay from './Flag/FlagDisplay';
import SignUp from '../SignUp';
import SignIn from '../SignIn';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

function MyVerticallyCenteredModal(props) {
    const styles = {
        backgroundColor: "#F0F0F0",
        borderRadius: "5px"
    }

    const HeadStyle = {
        backgroundColor: "#F0F0F0",
    }


    // State to track the current mode (sign-in or sign-up)
    const [mode, setMode] = useState('signin');

    // Function to switch between sign-in and sign-up modes
    const handleSetMode = (mode) => {
        setMode(mode);
    };
    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton style={HeadStyle}></Modal.Header>
            <Modal.Body style={styles}>
                <div className="d-flex justify-content-center alignos ">
                    <button className="btn btn-link" onClick={() => handleSetMode('signin')}>
                        Sign In
                    </button>
                    <span className="mx-2">|</span>
                    <button className="btn btn-link" onClick={() => handleSetMode('signup')}>
                        Sign Up
                    </button>
                </div>
                {mode === 'signin' ? (
                    <SignIn handleclosemodal={props.handleclosemodal} notifylogin={props.notifylogin} />
                ) : (
                    <SignUp handleclosemodal={props.handleclosemodal} notifylogin={props.notifylogin} />
                )}

            </Modal.Body>
        </Modal>
    );
}


function BlogNav(props) {
    const [displayName, setDisplayName] = useState(null);
    const [display, setDisplay] = useState(null);
    const { currentUser, logout } = useAuth();

    const [modalShow, setModalShow] = React.useState(false);
    // State to store the user's subscription status
    const [hasSubscription, setHasSubscription] = useState(false);


    const handleclosemodal = () => {
        setModalShow(false);
    };
    const handleShowModal = () => {
        setModalShow(true);
    };

    const notifyLogOut = () => {
        toast.info('Youve Logged Out!', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }


    let navy = useRef(null);

    useEffect(() => {
        return () => {
            gsap.from(navy, { duration: 1, opacity: 0, y: 140, ease: Power3.easeOut, stagger: .2 })
        };
    }, []);
    const history = useHistory();

    const handleLogout = async () => {
        try {
            history.push("/blog");
            await logout();
            
            notifyLogOut();
            // Redirect or update state as needed after logout
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };




    useEffect(() => {


        // Ensure the user is authenticated before fetching the image
        if (currentUser) {
            const userRef = firebase.firestore().collection('users').doc(currentUser.uid);

            // Fetch the user document from Firestore
            userRef.get().then((doc) => {
                if (doc.exists) {
                    // Access the 'photoUrl' field from the user document
                    const displayName = doc.data().displayName;
                    setDisplayName(displayName);
                    const photoUrl = doc.data().photoURL;
                    setDisplay(photoUrl);
                } else {
                    console.log('User document not found.');

                }
            }).catch((error) => {
                console.error('Error fetching user document:', error);
            });
        }
        else {
            setDisplay(null);
            setDisplayName(null);
        }
    }, [currentUser])

    useEffect(() => {
        // Get the currently authenticated user
        const currentUser = firebase.auth().currentUser;

        // Ensure the user is authenticated before fetching the subscription status
        if (currentUser) {
            const userRef = firebase.firestore().collection('users').doc(currentUser.uid);

            // Fetch the user document from Firestore
            userRef.get().then((doc) => {
                if (doc.exists) {
                    // Access the 'subscription' field from the user document
                    const subscription = doc.data().subscribed;
                    setHasSubscription(subscription === true);
                } else {
                    console.log('User document not found.');
                }
            }).catch((error) => {
                console.error('Error fetching user document:', error);
            });
        }
        else {

        }
    }, [currentUser]);



    return (
        <>
            <MyVerticallyCenteredModal
                show={modalShow}
                handleShowModal={handleShowModal}
                onHide={() => setModalShow(false)}
                // Pass handleclosemodal function to MyVerticallyCenteredModal
                handleclosemodal={handleclosemodal}
            />
            <div className='shower'>
                <ToastContainer />
                <div className="topper">
                    <div className="sign">

                        {currentUser ? (
                            <div className="user-profile">
                                <Link to="/profile">
                                    <div className="picky">

                                        <img
                                            src={currentUser.photoURL !== null ? currentUser.photoURL : display}
                                            alt="Profile"
                                            className="profile-picture"
                                        />
                                    </div>
                                </Link>
                                <div className="logiu">
                                    <h4 className='displayName'>{currentUser.displayName || displayName}</h4>
                                    <FlagDisplay />
                                    <h4 onClick={handleLogout} className='logoutBtn'><BiLogOutCircle /></h4>
                                </div>
                            </div>
                        ) : (

                            <h4 onClick={() => setModalShow(true)} >Sign In</h4>

                        )}

                    </div>
                    <div className="Brand hiddenBrand">

                        <h4>mete & design.</h4>

                    </div>

                    <div className="postit">
                        <BiSearch className='searchIcon' />
                        {hasSubscription && currentUser && (
                            <Link to="/createpost">
                                <button className='newPostBtn'>
                                    <h4 >New Post</h4>
                                </button>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
            <Navbar expand="lg" className=" transparent" sticky="top" ref={el => navy = el} >
                <Container className="curved  blogNav  " fluid>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" className='mete-btn' />

                    <Navbar.Collapse id="basic-navbar-nav" >
                        <Nav className=" NavItems justify-content-center" >
                            <Nav.Link className='links active' >Latest</Nav.Link>
                            <Nav.Link className='links' href="#Blog" >Tutorials</Nav.Link>
                            <Nav.Link className='links' href="#Services" >Web Design</Nav.Link>
                            <NavDropdown title={
                                <span className="links">Design</span>
                            } id="basic-nav-dropdown" >
                                <NavDropdown.Item href="#action/3.1" className='droppy'>Graphic Design</NavDropdown.Item>
                                <NavDropdown.Item href="#action/3.2" className='droppy'>
                                    UI/UX Design
                                </NavDropdown.Item>
                                <NavDropdown.Item href="#action/3.3" className='droppy'>Blender</NavDropdown.Item>
                                <NavDropdown.Item href="#action/3.3" className='droppy'>Fashion</NavDropdown.Item>

                            </NavDropdown>
                            <Nav.Link className='links' href="#AboutMe" >React Js</Nav.Link>
                            <Nav.Link className='links' href="#Tech" >Technology</Nav.Link>
                            <Nav.Link className='links' href="#News" >News</Nav.Link>
                            <Nav.Link className='links' href="#billing" >Subscription</Nav.Link>

                        </Nav>
                    </Navbar.Collapse>

                </Container>
            </Navbar>
            <section className="cutscene">

            </section>






        </>

    )
}

export default BlogNav
